// frontend/src/admin/components/AdminHeader.js
import React, { useState } from 'react';
import { Bell, User, LogOut, Menu, Shield, Activity, DollarSign, Users } from 'lucide-react';
import styles from '../styles/AdminHeader.module.css';

const AdminHeader = ({ onMenuClick, adminUser, liveStats, onLogout }) => {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);

  // ✅ Valeurs safe si liveStats est null au premier render
  const safeStats = liveStats || {
    usersOnline: 0,
    errorsLastHour: 0,
    revenueToday: '0.00',
    systemHealth: 'unknown',
  };

  const systemLabel =
    safeStats.systemHealth === 'healthy'
      ? 'Système OK'
      : safeStats.systemHealth === 'warning'
      ? 'Attention'
      : safeStats.systemHealth === 'critical'
      ? 'Critique'
      : 'Inconnu';

  return (
    <header className={styles.adminHeader}>
      {/* Left Section - Menu + Live Stats */}
      <div className={styles.adminHeader__left}>
        <button
          className={styles.adminHeader__menuBtn}
          onClick={onMenuClick}
        >
          <Menu size={20} />
        </button>

        {/* Live Stats Indicators */}
        <div className={styles.adminHeader__liveStats}>
          <div className={styles.adminLiveStat}>
            <Users size={16} />
            <span>{safeStats.usersOnline}</span>
            <small>en ligne</small>
          </div>

          <div className={styles.adminLiveStat}>
            <Activity size={16} />
            <span className={safeStats.errorsLastHour > 5 ? styles.error : styles.success}>
              {safeStats.errorsLastHour}
            </span>
            <small>erreurs/h</small>
          </div>

          <div className={styles.adminLiveStat}>
            <DollarSign size={16} />
            <span>{safeStats.revenueToday}€</span>
            <small>aujourd&apos;hui</small>
          </div>

          <div className={`${styles.adminSystemStatus} ${styles[safeStats.systemHealth || 'unknown']}`}>
            <div className={styles.statusIndicator}></div>
            <span>{systemLabel}</span>
          </div>
        </div>
      </div>

      {/* Right Section - Notifications + User */}
      <div className={styles.adminHeader__right}>
        {/* Notifications */}
        <div className={styles.adminHeader__notifications}>
          <button
            className={styles.adminNotificationBtn}
            onClick={() => setShowNotifications(!showNotifications)}
          >
            <Bell size={20} />
            <span className={styles.notificationBadge}>3</span>
          </button>

          {showNotifications && (
            <div className={styles.adminNotificationDropdown}>
              <div className={styles.notificationHeader}>
                <h4>🚨 Notifications</h4>
                <button>Tout marquer lu</button>
              </div>
              <div className={styles.notificationList}>
                <div className={`${styles.notificationItem} ${styles.unread}`}>
                  <div className={styles.notificationIcon}>⚠️</div>
                  <div className={styles.notificationContent}>
                    <div className={styles.notificationTitle}>Erreurs API augmentées</div>
                    <div className={styles.notificationTime}>Il y a 5 minutes</div>
                  </div>
                </div>
                <div className={styles.notificationItem}>
                  <div className={styles.notificationIcon}>💰</div>
                  <div className={styles.notificationContent}>
                    <div className={styles.notificationTitle}>Nouveau paiement reçu</div>
                    <div className={styles.notificationTime}>Il y a 15 minutes</div>
                  </div>
                </div>
                <div className={styles.notificationItem}>
                  <div className={styles.notificationIcon}>👤</div>
                  <div className={styles.notificationContent}>
                    <div className={styles.notificationTitle}>50 nouveaux utilisateurs</div>
                    <div className={styles.notificationTime}>Il y a 1 heure</div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* User Menu */}
        <div className={styles.adminHeader__user}>
          <button
            className={styles.adminUserBtn}
            onClick={() => setShowUserMenu(!showUserMenu)}
          >
            <Shield size={18} />
            <div className={styles.adminUserInfo}>
              <span className={styles.adminUserName}>{adminUser?.username || 'Admin'}</span>
              <span className={styles.adminUserRole}>{adminUser?.role || 'admin'}</span>
            </div>
            <User size={20} />
          </button>

          {showUserMenu && (
            <div className={styles.adminUserDropdown}>
              <div className={styles.adminUserDropdown__header}>
                <div className={styles.adminUserAvatar}>
                  <Shield size={24} />
                </div>
                <div className={styles.adminUserDetails}>
                  <div className={styles.adminUserName}>{adminUser?.username}</div>
                  <div className={styles.adminUserEmail}>{adminUser?.email}</div>
                  <div className={styles.adminUserRoleBadge}>
                    {adminUser?.role === 'super_admin' ? '👑 Super Admin' : '🛡️ Admin'}
                  </div>
                </div>
              </div>

              <div className={styles.adminUserDropdown__actions}>
                <button className={styles.adminUserAction}>
                  <User size={16} />
                  Mon Profil
                </button>
                <button className={styles.adminUserAction}>
                  <Shield size={16} />
                  Paramètres Admin
                </button>
                <div className={styles.adminUserDivider}></div>
                <button
                  className={`${styles.adminUserAction} ${styles.adminUserActionLogout}`}
                  onClick={onLogout}
                >
                  <LogOut size={16} />
                  Se Déconnecter
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;